import { useQuery, useQueryClient } from 'react-query'

import { ChamadoProdutoService } from '../services/chamado-produto.service'
import { ChamadoService } from '../services/chamado.service'

export const useGetCallProducts = (callId?: string | number) => {
  const queryClient = useQueryClient()

  const query = useQuery(
    ['useGetCallProducts', { callId: Number(callId) }],
    async () => {
      if (callId) {
        const { callProducts, isEditable } =
          await ChamadoProdutoService.search({
            callId: Number(callId),
          })
        const call = await ChamadoService.findById({
          callId: Number(callId),
        })

        return {
          callProducts,
          isEditable,
          equipmentId: call.Asset?.equipmentId,
        }
      }
    },
  )

  function invalidateCallProducts() {
    queryClient.invalidateQueries(['useGetCallProducts', { callId }])
  }

  return { query, invalidateCallProducts }
}
